module.exports = __webpack_public_path__ + "img/responsive hospitium-09.60dc69c3.jpg";